import React, { FC } from "react";
import classNames from "classnames";
import { SbGatsbyStory, useStoryblokState } from "gatsby-source-storyblok";
import { PageContent } from "./models";
import { COMPONENTS_MAP } from "./components/constants";

type Props = {
  content: SbGatsbyStory;
};

export const BasePage: FC<Props> = ({ content }) => {
  const entry = useStoryblokState(content) as unknown as PageContent;

  return (
    <div className={classNames("flex flex-col pb-20", "lg:pb-25", "xl:pb-40")}>
      {[...(entry.content?.hero ?? []), ...(entry.content?.content ?? [])].map(
        (component) =>
          React.createElement(
            COMPONENTS_MAP[component.component] ?? React.Fragment,
            COMPONENTS_MAP[component.component]
              ? { ...component, key: component._uid, content: component }
              : { key: component._uid },
          ),
      )}
    </div>
  );
};
